import { render } from "./CVEDetailDataList.vue?vue&type=template&id=437958ce&scoped=true"
import script from "./CVEDetailDataList.vue?vue&type=script&lang=js"
export * from "./CVEDetailDataList.vue?vue&type=script&lang=js"

import "./CVEDetailDataList.vue?vue&type=style&index=0&id=437958ce&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437958ce"]])

export default __exports__